// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"334":"f667ade7","557":"3837a877"}[chunkId] + ".chunk.css";
};